import { createRedux } from 'src/firebase';
import { Merchant } from 'src/store';

const {
  actions,
  actionTypes,
  collectionReducer: merchantsReducer,
  docReducer: merchantDetailReducer,
} = createRedux<Merchant>('merchants');

export {
  actions,
  actionTypes,
  merchantsReducer,
  merchantDetailReducer,
};



// WEBPACK FOOTER //
// ./src/merchants/redux.ts